import { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from '../../components/Header';
import api from '../../api';

const CORES = { urgente: '#C62828', alta: '#E07A0B', normal: '#4A8C64', baixa: '#7a7a7a' };
const ESTADOS = {
  ativo:    { l: 'No ar',     cor: '#4A8C64' },
  agendado: { l: 'Agendado',  cor: '#E07A0B' },
  expirado: { l: 'Expirado',  cor: '#8a8a8a' },
};

const fmt = (d) => d ? new Date(d).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit' }) : '—';

export default function CentralAvisos() {
  const navigate = useNavigate();
  const [avisos, setAvisos] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [filtro, setFiltro] = useState('');
  const [estado, setEstado] = useState('');

  useEffect(() => { carregar(); }, []);

  async function carregar() {
    try {
      const { data } = await api.get('/avisos/gestao');
      setAvisos(data.avisos);
    } catch (err) {
      Swal.fire('Erro', err.response?.data?.error || 'Não foi possível carregar os avisos.', 'error');
    } finally { setCarregando(false); }
  }

  const lista = useMemo(() => {
    const q = filtro.trim().toLowerCase();
    return avisos.filter(a =>
      (!q || a.titulo.toLowerCase().includes(q)) && (!estado || a.estado === estado)
    );
  }, [avisos, filtro, estado]);

  async function excluir(a) {
    const r = await Swal.fire({
      icon: 'warning', title: 'Excluir este aviso?',
      html: `<strong>${a.titulo}</strong><br>Ele sai do mural imediatamente.`,
      showCancelButton: true, confirmButtonText: 'Sim, excluir', cancelButtonText: 'Cancelar',
      confirmButtonColor: '#C62828',
    });
    if (!r.isConfirmed) return;
    try {
      await api.delete(`/avisos/${a.id}`);
      setAvisos(prev => prev.filter(x => x.id !== a.id));
    } catch (err) {
      Swal.fire('Erro', err.response?.data?.error || 'Não foi possível excluir.', 'error');
    }
  }

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 1000 }}>
        <Link to="/avisos" className="doc-voltar"><i className="bi bi-arrow-left"></i> Mural</Link>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
          <div>
            <h1 style={{ color: 'var(--verde)', fontWeight: 700, marginBottom: 4 }}>Central de Avisos</h1>
            <p style={{ color: 'var(--texto-suave)', marginTop: 0 }}>
              Tudo que já foi publicado — edite, tire do ar e acompanhe quantos viram.
            </p>
          </div>
          <Link to="/admin/avisos/novo" className="btn-centrao"><i className="bi bi-plus-lg me-1"></i> Novo aviso</Link>
        </div>

        <div className="acesso-filtros">
          <div className="doc-busca" style={{ flex: 2, marginBottom: 0 }}>
            <i className="bi bi-search"></i>
            <input type="text" placeholder="Buscar por título…" value={filtro} onChange={e => setFiltro(e.target.value)} />
            {filtro && <button type="button" className="doc-busca-limpar" onClick={() => setFiltro('')}>×</button>}
          </div>
          <select className="doc-input" style={{ flex: 1 }} value={estado} onChange={e => setEstado(e.target.value)}>
            <option value="">Todos os estados</option>
            <option value="ativo">No ar</option>
            <option value="agendado">Agendado</option>
            <option value="expirado">Expirado</option>
          </select>
        </div>

        {carregando && <div>Carregando…</div>}

        {!carregando && lista.length === 0 && (
          <div className="conteudo-card" style={{ textAlign: 'center', padding: '38px 16px', color: 'var(--texto-suave)' }}>
            <i className="bi bi-megaphone" style={{ fontSize: '2.2rem' }}></i>
            <p style={{ marginTop: 10 }}>{avisos.length === 0 ? 'Nenhum aviso publicado ainda.' : 'Nada com esses filtros.'}</p>
          </div>
        )}

        <div className="acesso-lista">
          {lista.map(a => (
            <div className="acesso-row" key={a.id} style={{ borderLeft: `4px solid ${CORES[a.prioridade] || CORES.normal}` }}>
              <div className="acesso-info" style={{ minWidth: 0 }}>
                <div className="acesso-info-txt" style={{ minWidth: 0 }}>
                  <div className="acesso-nome">{a.titulo}</div>
                  <div className="acesso-sub">
                    <span style={{ color: ESTADOS[a.estado]?.cor, fontWeight: 700 }}>{ESTADOS[a.estado]?.l}</span>
                    {' · '}{fmt(a.data_inicio || a.created_at)}
                    {a.data_fim && ` até ${fmt(a.data_fim)}`}
                    {' · '}<i className="bi bi-eye"></i> {a.visualizacoes} viram
                    {a.autor && ` · por ${a.autor.split(' ')[0]}`}
                  </div>
                </div>
              </div>
              <div className="acesso-acoes">
                <Link to={`/admin/avisos/${a.id}/editar`} className="btn-centrao-laranja" title="Editar">
                  <i className="bi bi-pencil"></i>
                </Link>
                <button className="doc-btn-excluir" onClick={() => excluir(a)} title="Excluir">
                  <i className="bi bi-trash"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </main>
    </>
  );
}
